/* eslint-disable */
import router from './router';
import store from '@/store';
import getPageTitle from '@/utils/get-page-title';
import { getUser, setUser } from '@utils/auth';
import { env, ILocalStorage, abUuid, JS2Native } from '@utils';
import { divideAbRouter } from '@utils/abtest.js';

router.beforeEach(async (to, from, next) => {
  // 全局通过url参数进行免登 暂时只支持wxtoken userinfo包含 uid token
  // wxtoken是从小程序授权后 生成的专用token
  if (to.query.uid && to.query.wxtoken) {
    // const {uid, wxtoken, phone, ...qParams} = to.query
    setUser(JSON.stringify({
      uid: to.query.uid,
      token: to.query.wxtoken.replace(/ /g,'+'),
      wxtoken: to.query.wxtoken.replace(/ /g,'+'),
      phone: to.query.phone
    }));
    // next({
    //   name: to.name,
    //   query: qParams,
    //   replace: true
    // });
    // return;
  }

  if ((to.name === 'courseItem' || to.name === 'oneKeyBuyNew')
      && (to.query.itemid === '1447403010116001793' || to.query.itemid === '1447403307559264258'
      || to.query.itemid === '1433682636306141186' || to.query.itemid === '1428562436497121281')
      && !from.name && !to.query.abFlag) {
    let abActivityId = '';
    let ab_uuid = '';
    let lastUrl = '';
    let lastBucketName = '';

    // 线上测试组
    if (to.query.itemid === '1447403010116001793' || to.query.itemid === '1447403307559264258') {
      abActivityId = '1447403878740148226';
    }

    // 线上业务测试用
    if (to.query.itemid === '1433682636306141186' || to.query.itemid === '1428562436497121281') {
      abActivityId = '1452843562469867521';
    }



    if (ILocalStorage('abID') && ILocalStorage(abActivityId)) {
      ab_uuid = JSON.parse(ILocalStorage(abActivityId)).ab_uuid;
      lastUrl = JSON.parse(ILocalStorage(abActivityId)).lastUrl ? JSON.parse(ILocalStorage(abActivityId)).lastUrl : '';
      lastBucketName = JSON.parse(ILocalStorage(abActivityId)).bucketName ? JSON.parse(ILocalStorage(abActivityId)).bucketName : '';
    } else {
      ab_uuid = abUuid();
      ILocalStorage(abActivityId, JSON.stringify({ 'ab_uuid': ab_uuid }));
    }

    const params = {
      activityId: abActivityId,
      whiteBucketName: to.query.whiteBucketName,
      sessionId: ab_uuid,
      lastUrl: lastUrl,
      lastBucketName: lastBucketName,
      igc_from: to.query.igc_from
    };
    await divideAbRouter(params);
  }

  if (to.name === 'courseItem' && from.name === 'h5pay_order') {
    //  无规格自动跳转标识
    sessionStorage.setItem('isNoParamsCourse', true);
  }
  const { meta: { auth } } = to;
  if (to.meta.title) {
    document.title = getPageTitle(to.meta.title);
  }

  const userInfo = getUser();
  store.commit('muSetUserInfo', JSON.parse(userInfo) || {});

  if (env.isApp) {
    const res = await store.dispatch('acPutAppUserinfo');
    if (res.uid || !auth) {
      next();
      return;
    }
    if (auth) {
      const r = await store.dispatch('acAppLogin');
      if (r.data) {
        store.dispatch('acPutAppUserinfo').then(res => {
          next();
        });
      } else {
        next(false);
      }
    }
    // JS2Native({
    //   name: 'getAppUserPid',
    // }).then(({ data }) => {
    //   if (data) {
    //     const uid = data;
    //     JS2Native({
    //       name: 'getUserInfo'
    //     }).then(({ data }) => {
    //       const userInfo = {};
    //       userInfo['App-Device-Key'] = data['App-Device-Key'];
    //       userInfo['App-Device-Type'] = data['App-Device-Type'];
    //       userInfo['APP-Agent'] = data['App-Version'];
    //       userInfo['App-Sign'] = data['App-Token'];
    //       userInfo['uid'] = uid;
    //       setUser(JSON.stringify(userInfo));
    //       next();
    //     });
    //   } else {
    //     if (!auth) {
    //       next();
    //       return;
    //     }
    //     JS2Native({
    //       name: 'doLogin',
    //     }).then((res) => {
    //       if (res.data) {
    //         const uid = res.data;
    //         JS2Native({
    //           name: 'getUserInfo'
    //         }).then(({ data }) => {
    //           const userInfo = {};
    //           userInfo['App-Device-Key'] = data['App-Device-Key'];
    //           userInfo['App-Device-Type'] = data['App-Device-Type'];
    //           userInfo['APP-Agent'] = data['App-Version'];
    //           userInfo['App-Sign'] = data['App-Token'];
    //           userInfo['uid'] = uid;
    //           setUser(JSON.stringify(userInfo));
    //           next();
    //         });
    //       } else {
    //         next(false);
    //       }
    //     });
    //   }
    // });
  } else {
    if (auth && !userInfo) {
      const { path, query } = to;
      next({
        path: `/mall/login`,
        query: {
          redirect: path,
          ...query
        }
      });
    } else {
      if (userInfo && to.name === 'Login') {
        next(false);
      }
      next();
    }
  }
});